// extracted by mini-css-extract-plugin
export default {"defaultButton":"DefaultButton_defaultButton__zwrXN","selected":"DefaultButton_selected__H1nCP","disabled":"DefaultButton_disabled__Umrin"};